"use client";
//#region packages/@mantine/core/src/components/Popover/Popover.module.css
var Popover_module_default = {
	"dropdown": "m_38a85659",
	"arrow": "m_a31dc6c1",
	"overlay": "m_3d7bc908"
};
//#endregion
export { Popover_module_default as default };

//# sourceMappingURL=Popover.module.mjs.map